import { Injectable } from '@angular/core';
import { InfoWindowDialogComponent } from '../dialogs/info-window-dialog/info-window-dialog.component';
import { take } from 'rxjs/operators';
import { UserFacade } from '../../../store/facade/user.facade';
import { AppUser } from '../../core/user/AppUser';
import { ChannelService } from '../../core/services/channel.service';
import { InfoWindowTextChangedAction } from '../../core/models/hubActions/info-window-text-changed.action';
import { Subscription } from 'rxjs';

import { JeDialogService } from '../components/dialog/dialog.service';
@Injectable({
    providedIn: 'root',
})
export class InfoWindowDialogService {
    private infoWindowTextChangedSubscription: Subscription;
    constructor(
        private dialogService: JeDialogService,
        private userFacade: UserFacade,
        private channelService: ChannelService,
    ) {}

    public registerForNotification() {
        const infoWindowTextChangedAction = new InfoWindowTextChangedAction();

        this.infoWindowTextChangedSubscription = infoWindowTextChangedAction.infoWindowTextChanged$.subscribe(data => this.showDialog(data.infoText, data.visibilityId));

        this.channelService.switchOnAction(infoWindowTextChangedAction);
    }

    public unregisterForNotification() {
        this.infoWindowTextChangedSubscription?.unsubscribe();

        this.channelService.switchOffAction(InfoWindowTextChangedAction.ACTION_NAME);
    }

    public showDialog(infoText: string, visibilityId: number) {
        if (infoText == null) return;
        if (visibilityId == null) return;

        this.userFacade.userGroup$.pipe(take(1)).subscribe(group => {
            if (group == null || group === AppUser.GROUP_NO_GROUP) return;
            if ((group === AppUser.GROUP_CONTRACTOR || group === AppUser.GROUP_CONTRACTOR_ADMIN) && visibilityId == 2) return;
            if (group === AppUser.GROUP_CUSTOMER && visibilityId == 1) return;

            const dialogConfig = {
                disableClose: true,
                data: infoText,
                width: '75%',
            };
            this.dialogService.open(InfoWindowDialogComponent, dialogConfig);
        });
    }
}
